import { createSlice } from '@reduxjs/toolkit';

const teamsChatSlice = createSlice({
  name: 'teamsChat',
  initialState: {},
  reducers: {},
});

export default teamsChatSlice.reducer;
